import PosConsoleApi from "app/utils/PosConsoleApi";
import * as React from "react";
import TopBar from "./Ops.CardTerminalsTopBar";
import Button from "@material-ui/core/Button";
import "./style.css";

type State = {
  search: string;
  file: File;
  uploading: boolean;
  response: String;
};

export default class UploadsContainer extends React.Component<any, State> {
  state = {
    search: null,
    file: null,
    uploading: false,
    response: "",
  };

  handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === "text/csv") {
      this.setState({ file: selectedFile });
    } else {
      this.setState({ file: null });
      alert("Please select a CSV file.");
    }
  };

  handleUploadClick = (event: any) => {
    if (!this.state.file) {
      return;
    }
    this.setState({ uploading: true });
    console.log(this.state.file);
    PosConsoleApi.postMultipart("card_terminal/csv_import", {
      file: this.state.file,
    })
      .then((response) => response.json())
      .then((response) => {
        this.setState({ uploading: false });
        alert(response.message);
      })
      .catch((error) => {
        this.setState({ uploading: false });
        alert(error);
      });
  };

  render() {
    return (
      <React.Fragment>
        <TopBar />
        <section className="padded">
          <h1 style={{ margin: 1 }}>Add Card Terminals</h1>
          <div>Upload new card terminal CSV file in the correct format.</div>
          <h6 style={{ marginBottom: "0px" }}>
            Import SBSA terminal identifiers &amp; Identifiers example:
          </h6>
          <pre
            className="csv-example"
            style={{
              width: "400px",
              height: "60px",
            }}
          >
            <div>CL0A,PN76232N30727</div>
            <div>CL1A,PN76232N30726</div>
          </pre>
          <input
            type="file"
            onChange={this.handleFileUpload}
            style={{ margin: 5 }}
          />
          <Button
            component="span"
            disabled={this.state.uploading || !this.state.file}
            variant="contained"
            color="primary"
            onClick={this.handleUploadClick}
            style={{
              margin: "5px",
              width: "110px",
              height: "30px",
            }}
          >
            {this.state.uploading ? "Uploading..." : "Submit"}
          </Button>
          <div>{this.state.response}</div>
        </section>
      </React.Fragment>
    );
  }
}
